import React from "react";
import { useIntl } from "react-intl";
import { Modal } from "@jelly/ui";

import styles from "./Modals.module.scss";
import { messages } from "../Workspace.messages";
import { useBlocks, useUi } from "@jelly/lesson";
import * as appConfig from "appConfig";
import { nl2p } from "@src/utils/nl2p";

type ModalProps = Omit<React.ComponentProps<typeof Modal>, "children">;
export const LoudspeakersModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P2_M_Loudspeakers_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P2_M_Loudspeakers_Description))}</div>
          <div className={styles.rightColumn}>
            <div className={styles.image}>
              <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/en/modal_loudspeakers.svg`} />
            </div>
            <p className={styles.caption}>{formatMessage(messages.G2_P2_M_Loudspeakers_Caption)}</p>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const StudioRoomModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P2_M_StudioRoom_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P2_M_StudioRoom_Description))}</div>
          <div className={styles.rightColumn}>
            <div className={styles.image}>
              <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/en/modal_room.svg`} />
            </div>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const HeadphonesModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P2_M_Headphones_Title1)}>
      <div className={styles.root}>
        {nl2p(formatMessage(messages.G2_P2_M_Headphones_Description1))}
        <h1>{formatMessage(messages.G2_P2_M_Headphones_Title2)}</h1>
        {nl2p(formatMessage(messages.G2_P2_M_Headphones_Description2))}
      </div>
    </ui.Modal>
  );
};

export const MonitoringControllerModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P2_M_MonitoringController_Title)}>
      <div className={styles.root}>{nl2p(formatMessage(messages.G2_P2_M_MonitoringController_Description))}</div>
    </ui.Modal>
  );
};

export const AudioInterfaceModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P2_M_AudioInterface_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns30}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P2_M_AudioInterface_Description))}</div>
          <div className={styles.rightColumn}>
            <h3>{formatMessage(messages.G2_P2_M_AudioInterface_Title2)}</h3>
            <p>
              <strong>{formatMessage(messages.G2_P2_M_AudioInterface_P1_Title)}:</strong>{" "}
              {formatMessage(messages.G2_P2_M_AudioInterface_P1_Description)}
            </p>
            <p>
              <strong>{formatMessage(messages.G2_P2_M_AudioInterface_P2_Title)}:</strong>{" "}
              {formatMessage(messages.G2_P2_M_AudioInterface_P2_Description)}
            </p>
            <p>
              <strong>{formatMessage(messages.G2_P2_M_AudioInterface_P3_Title)}:</strong>{" "}
              {formatMessage(messages.G2_P2_M_AudioInterface_P3_Description)}
            </p>
            <p>
              <strong>{formatMessage(messages.G2_P2_M_AudioInterface_P4_Title)}:</strong>{" "}
              {formatMessage(messages.G2_P2_M_AudioInterface_P4_Description)}
            </p>
            <p>
              <strong>{formatMessage(messages.G2_P2_M_AudioInterface_P5_Title)}:</strong>{" "}
              {formatMessage(messages.G2_P2_M_AudioInterface_P5_Description)}
              <ul>
                <li>{nl2p(formatMessage(messages.G2_P2_M_AudioInterface_P5_L1))}</li>
                <li>{nl2p(formatMessage(messages.G2_P2_M_AudioInterface_P5_L2))}</li>
                <li>{nl2p(formatMessage(messages.G2_P2_M_AudioInterface_P5_L3))}</li>
              </ul>
            </p>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};

export const AcousticsModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P2_M_Acoustics_Title)}>
      <div className={styles.root}>{nl2p(formatMessage(messages.G2_P2_M_Acoustics_Description))}</div>
    </ui.Modal>
  );
};

export const MicrophonesModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P2_M_Microphones_Title)}>
      <div className={styles.root}>{nl2p(formatMessage(messages.G2_P2_M_Microphones_Description))}</div>
    </ui.Modal>
  );
};

export const DawModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P2_M_Microphones_Title)}>
      <div className={styles.root}>
        {nl2p(formatMessage(messages.G2_P2_M_Daw_Description1))}
        <div className={styles.image} style={{ height: "150px", width: "auto" }}>
          <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/en/modal_daw.svg`} />
        </div>
        {nl2p(formatMessage(messages.G2_P2_M_Daw_Description2))}
      </div>
    </ui.Modal>
  );
};

export const VirtualisationModal: React.FC<ModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();
  const blocks = useBlocks();

  return (
    <ui.Modal {...props} title={formatMessage(messages.G2_P2_M_Virtualisation_Title)}>
      <div className={styles.root}>
        <div className={styles.twoColumns30}>
          <div className={styles.leftColumn}>{nl2p(formatMessage(messages.G2_P2_M_Virtualisation_Description1))}</div>
          <div className={styles.rightColumn}>
            {nl2p(formatMessage(messages.G2_P2_M_Virtualisation_Description2))}
            <div className={styles.image} style={{ height: "350px", width: "100%" }}>
              <blocks.image src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide02/modal_virtualisation.png`} />
            </div>
          </div>
        </div>
      </div>
    </ui.Modal>
  );
};
